import {
  matchRule,
  maxLengthRule,
  minLengthRule,
  requiredRule,
  useFormControl,
  type FormControlProps,
} from "@mongez/react-form";
import { useState } from "react";
import { cn } from "~/shared/lib";
import { Button } from "../button";
import { CloseEye, OpenEye } from "../icons";
import { ErrorInput } from "./ErrorInput";
import { LabelInput } from "./LabelInput";

type PasswordInputProps = FormControlProps & {
  classes?: {
    wrapper?: string;
    label?: string;
    input?: string;
    error?: string;
  };
};

export function PasswordInput({
  rules = [],
  label,
  classes,
  ...props
}: PasswordInputProps) {
  const [showPassword, setShowPassword] = useState(false);
  const { id, error, name, value, changeValue, otherProps } = useFormControl({
    ...props,
    rules: [requiredRule, minLengthRule, maxLengthRule, matchRule, ...rules],
  });

  return (
    <div className={cn("w-full relative flex flex-col gap-2", classes?.wrapper)}>
      <LabelInput
        htmlFor={id}
        required={props.required}
        className={classes?.label}
      >
        {label}
      </LabelInput>
      <div className="relative flex items-center gap-2">
        <input
          id={id}
          name={name}
          type={showPassword ? "text" : "password"}
          value={value}
          onChange={(e) => changeValue(e.target.value)}
          {...otherProps}
          className={cn(
            "focus:border-primary-500 focus:ring-primary-default bg-primary-light w-full rounded-full border border-black px-6 py-4 text-black focus:ring-1 focus:outline-none",
            error && "border-red-500",
            classes?.input,
          )}
        />
        <Button
          type="button"
          onClick={() => setShowPassword(!showPassword)}
          className="absolute top-1/2 -translate-y-1/2 cursor-pointer text-sm text-black ltr:right-2 rtl:left-2"
        >
          {showPassword ? <OpenEye /> : <CloseEye />}
        </Button>
      </div>
      <ErrorInput className={classes?.error}>{error}</ErrorInput>
    </div>
  );
}
